import { createFileRoute } from '@tanstack/react-router'
import TrustPage from '@/pages/trust'
import { buildHead } from '@/shared/seo/seo-config'
import { redirectIfPublicPageHidden } from '@/shared/lib/hidden-public-pages'

export const Route = createFileRoute('/$lang/trust')({
  beforeLoad: ({ params }) => redirectIfPublicPageHidden('trust', params.lang),
  head: ({ params }) => buildHead('trust', params.lang),
  component: TrustPage,
  staticData: { layout: 'public' },
})
